"use client";

import { InlineInfoBox } from "staysure-component-library";

import RichText from "@/components/atoms/rich-text/rich-text";
import {
  ELIGIBLE,
  WITHDRAWAL_REQUESTED,
  WITHDRAWN,
} from "@/config/app-constant";
import { useWithdrawal } from "@/hooks/withdrawal/use-withdrawal";

interface FinancialSummaryProps {
  sectionTitle?: string;
  originalPremiumLabel?: string;
  finalRefundSectionTitle?: string;
  paidOnLabel?: string;
  infoBoxRichText?: string;
  originalPremium: string;
  paidOn: string;
}

export default function FinancialSummary({
  sectionTitle,
  finalRefundSectionTitle,
  originalPremiumLabel,
  paidOnLabel,
  infoBoxRichText,
  originalPremium,
  paidOn,
}: Readonly<FinancialSummaryProps>) {
  const { policyData } = useWithdrawal();

  const eligibilityStatus =
    policyData?.withdrawalData.withdrawalEligibilityStatus;
  return (
    <div className="mb-spacing-l">
      {sectionTitle && (
        <h2 className="font-header-font text-l text-text-title font-normal leading-[28px] mb-spacing-l">
          {sectionTitle}
        </h2>
      )}

      <div className="flex justify-between items-start gap-spacing-m mb-spacing-xs">
        <div>
          {originalPremiumLabel && (
            <p className="font-body-font text-2xs font-normal text-text-functional-subtle leading-6">
              {originalPremiumLabel}
            </p>
          )}
          {paidOnLabel && (
            <p className="font-body-font text-4xs font-normal text-text-functional-subtle leading-4">
              {paidOnLabel} {paidOn}
            </p>
          )}
        </div>
        <p className="font-body-font text-2xs font-bold text-[#136A9C] leading-6 text-right whitespace-nowrap">
          €{originalPremium}
        </p>
      </div>

      {eligibilityStatus === WITHDRAWN && (
        <>
          <div className="border-t border-border-neutral-subtle my-spacing-s" />
          <div className="flex justify-between items-start gap-spacing-m">
            <p className="font-body-font text-2xs font-bold leading-6 text-text-functional-subtle">
              {finalRefundSectionTitle}
            </p>
            <p className="font-body-font text-s font-bold text-[#136A9C] leading-6 text-right whitespace-nowrap">
              €{originalPremium}
            </p>
          </div>
        </>
      )}

      {(eligibilityStatus === ELIGIBLE ||
        eligibilityStatus === WITHDRAWAL_REQUESTED) &&
        infoBoxRichText && (
          <InlineInfoBox
            tabIndex={-1}
            className="pl-[22px] pr-spacing-m py-spacing-xs w-full font-body-font font-normal text-3xs text-text-functional leading-[21px] rounded-lg border !border-border-info-primary mt-spacing-xs mx-auto bg-surface-info-2"
            content={<RichText richText={infoBoxRichText} />}
          />
        )}
    </div>
  );
}
